import {
  CssBaseline as MuiCssBaseline,
  CssBaselineProps as MuiCssBaselineProps,
} from '@mui/material';
import * as React from 'react';
import GlobalUnifyStyles from 'src/styles/themes/default/GlobalUnifyStyles';

export interface CssBaselineOwnProps {
  /**
   * @deprecated Unsupported prop: This prop is hardcoded to `true` in Unify and will be removed in a future major.
   * Please reach out to us in #unify-design-system-support if you have a use case for this prop.
   */
  enableColorScheme?: boolean;
}

export type CssBaselineProps = Omit<
  MuiCssBaselineProps,
  keyof CssBaselineOwnProps
> &
  CssBaselineOwnProps;

/**
 * Injects global `<style>` tags into the document to provide consistent global CSS var based
 * styling for the Unify system.
 *
 * Only nest one of these inside a single `UnifyThemeProvider` on the page at a time!
 */
export const CssBaseline: React.FC<CssBaselineProps> = ({ children }) => {
  return (
    <>
      <MuiCssBaseline enableColorScheme={true}>{children}</MuiCssBaseline>
      <GlobalUnifyStyles />
    </>
  );
};

export default CssBaseline;
